package com.flowyride.feature.navigation.ui

import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

/** Wider than high (phone in a landscape holder): the panels go in a column on the left, the map gets the full height. */
internal fun isLandscapeLayout(width: Dp, height: Dp): Boolean = width > height

/** About 40 % of the screen, enough for the banner and the bar at their portrait sizes. */
internal fun landscapeColumnWidth(width: Dp): Dp = (width * 0.4f).coerceIn(LandscapeColumnMin, LandscapeColumnMax)

private val LandscapeColumnMin = 290.dp
private val LandscapeColumnMax = 340.dp
